import { useSplit } from 'Hooks/useSplit'
import { useUserStore } from 'Stores/userStoreModuleFed'

const ceNoCreditCard = 'CE_NO_CREDIT_CARD_POPUP'

export const useNoCreditCardPopUpSplit = () => {
  const { forceNoCc } = useUserStore()
  const splitFlag = useSplit(ceNoCreditCard)

  return forceNoCc ? true : splitFlag
}
